// backendConfig.js
let VITE;
try { VITE = import.meta.env; } catch {}

const RUNTIME_BACKEND_URL =
  (typeof window !== "undefined" &&
    (window.__BACKEND_URL || localStorage.getItem("backendURL"))) || null;
const RUNTIME_SUPABASE_URL =
  (typeof window !== "undefined" && window.__SUPABASE_URL) || null;

export const backendURL =
  RUNTIME_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  (VITE && VITE.VITE_BACKEND_URL) ||
  "http://localhost:5001";

export const ACCOUNT_ID =
  (typeof window !== "undefined" && localStorage.getItem("accountId")) ||
  (VITE && VITE.VITE_ACCOUNT_ID) ||
  (backendURL.includes("execute-api") ? "xhandle-prod" : "dev-local");

const SUPABASE_URL =
  RUNTIME_SUPABASE_URL ||
  process.env.REACT_APP_SUPABASE_URL ||
  (VITE && VITE.VITE_SUPABASE_URL) ||
  "";

// Persist + debug
if (typeof window !== "undefined") {
  window.__BACKEND_URL = backendURL;
  localStorage.setItem("backendURL", backendURL);
  if (!localStorage.getItem("accountId")) {
    localStorage.setItem("accountId", ACCOUNT_ID);
  }
  console.info("[xHandle] backendURL =", backendURL, "ACCOUNT_ID =", ACCOUNT_ID);
}

// Optional helpers for authenticated fetches
function supabaseProjectRefFromUrl(value = SUPABASE_URL) {
  try {
    const host = new URL(value).hostname;
    return host.endsWith(".supabase.co") ? host.split(".")[0] : "";
  } catch {
    return "";
  }
}

function sessionFromStoredAuth(value) {
  const parsed = typeof value === "string" ? JSON.parse(value) : value;
  return parsed?.currentSession || parsed?.session || parsed || null;
}

function isExpiredSession(session) {
  const expiresAt = Number(session?.expires_at || session?.expiresAt || 0);
  return Number.isFinite(expiresAt) && expiresAt > 0 && expiresAt <= Math.floor(Date.now() / 1000);
}

function accessTokenFromStorageValue(value) {
  try {
    const session = sessionFromStoredAuth(value);
    if (!session || isExpiredSession(session)) return null;
    return session.access_token || session.accessToken || null;
  } catch {
    return null;
  }
}

export function getSupabaseAccessToken() {
  try {
    const projectRef = supabaseProjectRefFromUrl();
    const preferredKey = projectRef ? `sb-${projectRef}-auth-token` : "";
    if (preferredKey) {
      const preferredToken = accessTokenFromStorageValue(localStorage.getItem(preferredKey));
      if (preferredToken) return preferredToken;
    }

    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k || !k.startsWith("sb-") || !k.endsWith("-auth-token") || k === preferredKey) continue;
      const token = accessTokenFromStorageValue(localStorage.getItem(k));
      if (token) return token;
    }
  } catch {}
  return null;
}

export function getLocalAccessToken() {
  return getSupabaseAccessToken();
}

function normalizeAIProvider(provider) {
  const value = String(provider || "").trim().toLowerCase();
  if (value === "claude") return "anthropic";
  if (value === "google" || value === "google-gemini") return "gemini";
  if (value === "openai" || value === "anthropic" || value === "gemini") return value;
  return "openai";
}

function getStoredActiveAIProvider() {
  try {
    return normalizeAIProvider(localStorage.getItem("xhandle.aiProvider.active") || "openai");
  } catch {
    return "openai";
  }
}

function getStoredAIProviderModelPreference(provider) {
  const normalizedProvider = normalizeAIProvider(provider);
  try {
    return (
      localStorage.getItem(`xhandle.aiProviderModel.${normalizedProvider}`) ||
      localStorage.getItem("xhandle.aiProvider.activeModel") ||
      ""
    );
  } catch {
    return "";
  }
}

export function buildAuthOpts(extraHeaders = {}) {
  const bearer = getSupabaseAccessToken();
  return {
    credentials: "include",
    headers: {
      "x-account-id": ACCOUNT_ID,
      ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
      ...extraHeaders,
    },
  };
}

export function buildAIAuthOpts(extraHeaders = {}) {
  const provider = getStoredActiveAIProvider();
  const selectedModel = getStoredAIProviderModelPreference(provider);
  return buildAuthOpts({
    ...(provider ? { "x-ai-provider": provider } : {}),
    ...(selectedModel ? { "x-ai-model": selectedModel } : {}),
    ...extraHeaders,
  });
}
